export const LinkIcon = () => (
  <svg width={8} height={8} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.143.571c0-.315.256-.571.571-.571H7.43A.571.571 0 0 1 8 .571v5.715a.571.571 0 1 1-1.143 0V1.95L.975 7.833a.571.571 0 1 1-.808-.808L6.05 1.143H1.714A.571.571 0 0 1 1.143.57Z"
      fill="#171A1C"
    />
  </svg>
);
